import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ProductsList extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{},
            products:[]
        }
        

    }
 
    
    componentDidMount()
    {
        var data = { id : this.props.slug} 
            axios.post(api_base_url+"category_products", data).then(response=>{
                this.setState({products:response.data}); 
                this.setState({loading:0});
            }); 
    }
    componentDidUpdate(prevProps)
    {
        var data = { id : this.props.slug}
        if (this.props.slug !== prevProps.slug)
        {
            axios.post(api_base_url+"category_products", data).then(response=>{
                this.setState({products:response.data}); 
                this.setState({loading:0});
            });
        }
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
 {this.state.products.map((prod,key)=>(

    
                <div class="about-area inc-video default-padding-top">
                <div class="container">
                    <div class="row"> 
                    
                    <div class="about-content">

                        <div  class={key%2 === 1 ? "col-md-6 info-content" : "col-md-6 info-content dnone"}>
                        <h2><strong>{prod.title}</strong></h2>
                        <div  dangerouslySetInnerHTML={{ __html: prod.description}} />  
                        </div>
                        <div class="col-md-6">
                        <div class="thumb"> <img src={prod.image} alt={prod.title} /><br />
                            <br />
                        </div>
                        </div>
                        <div class={key%2 === 0? "col-md-6 info-content" : "col-md-6 info-content dnone"}>
                        <h2><strong>{prod.title}</strong></h2>
                        <div  dangerouslySetInnerHTML={{ __html: prod.description}} />  
                        </div>
                    </div>
                    
                    
                    </div>
                </div>
                </div>
 ))};
        </div>
       

    );
 
    }
}

export default ProductsList;